import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId:    process.env.REACT_APP_AZURE_AD_CLIENT_ID,
    authority:   `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_AD_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: { cacheLocation: 'sessionStorage', storeAuthStateInCookie: false },
};

export const loginRequest = { scopes: ['openid', 'profile', 'User.Read'] };

const msalInstance = new PublicClientApplication(msalConfig);

const INTERACTION_STATUS_KEY = /^msal\..*interaction\.status$/;

// Removes the persisted "interaction in progress" flag. MSAL leaves it behind
// when a popup is closed/reloaded mid-flow, which blocks every later sign-in
// with `interaction_in_progress`.
export function clearMsalInteractionState() {
  try {
    Object.keys(sessionStorage)
      .filter(key => INTERACTION_STATUS_KEY.test(key))
      .forEach(key => sessionStorage.removeItem(key));
  } catch { /* storage unavailable */ }
}

let ready = null;

// Settles handleRedirectPromise() once, and only then clears stale interaction
// state (clearing earlier could break a genuine in-flight redirect). Never
// rejects: a failed redirect must not prevent the login screen from rendering.
export function initMsal() {
  if (!ready) {
    ready = Promise.resolve()
      .then(() => msalInstance.handleRedirectPromise())
      .catch(() => null)
      .then(() => { clearMsalInteractionState(); });
  }
  return ready;
}

export default msalInstance;
